@if(!isUndefined()){
    <app-navbar></app-navbar>
        <div class="container pt-4">
            <div class="row">
                <div class="col-lg-8">
                    @if(isLoading()){
                        @for (item of [].constructor(2); track $index) {
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '480px', 'margin-bottom': '5px', 'width': '98%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '8%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '40%' }"></ngx-skeleton-loader>
                            <ngx-skeleton-loader count="5" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '10px', 'padding-bottom': '10px', 'width': '98%' }"></ngx-skeleton-loader>
                        }
                    }@else{
                        <div animate.enter="fadein" animate.leave="fadeout">
                            <div class="inter fs-7 mb-3 fw-medium breadcrumb cl-1">
                                <a [routerLink]="['/']" class="text-decoration-none">
                                    <strong>Home</strong>
                                </a>
                                <img src="assets/icons/arrow_right.svg" alt="Breadcrumb"> 
                                <a [routerLink]="['/articles/3/1']" class="text-decoration-none">
                                    <strong>Articles</strong>
                                </a>
                                <img src="assets/icons/arrow_right.svg" alt="Breadcrumb">
                                <span class="text-muted" [title]="article()?.title!">{{article()?.title! | truncate: 70}}</span>
                            </div>
                            <div class="thumbnail-lg w-100 mb-3 bg-white border border-light rounded-top-start rounded-top-end">
                                <img [src]="article()?.img!" [alt]="article()?.title!" class="object-fit-cover w-100 rounded-2 rounded-top-start rounded-top-end">
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="fs-7 p-0 mb-1 mt-2 inter">
                                        <a [routerLink]="['/categories', article()?.categorySlug!, 3, 1]" class="text-decoration-none border border-gray rounded-4 py-1 px-2 text-dark category">
                                            <img src="assets/icons/tag.svg" [alt]="article()?.category!"> {{article()?.category!}}
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="fs-8 p-0 mb-1 mt-2 inter">
                                        @if(article()?.prompt && article()?.bots!.length > 0){
                                            <ul class="list-unstyled list-inline p-0 mb-0 float-end">
                                                <li class="list-inline-item">
                                                    <span class="text-muted">Summarize with</span>
                                                </li>
                                                @for (obj of article()?.bots; track obj) {
                                                    @if(obj == 'ChatGPT'){
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-outline-light btn-bot bot-chatgpt" (click)="summarize(obj)" [title]="obj"></button>
                                                        </li>
                                                    }
                                                    @if(obj == 'Google Gemini'){
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-outline-light btn-bot bot-gemini" (click)="summarize(obj)" [title]="obj"></button>
                                                        </li>
                                                    }
                                                    @if(obj == 'Claude'){
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-outline-light btn-bot bot-claude" (click)="summarize(obj)" [title]="obj"></button>
                                                        </li>
                                                    }
                                                    @if(obj == 'Grok'){
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-outline-light btn-bot bot-grok" (click)="summarize(obj)" [title]="obj"></button>
                                                        </li>
                                                    }
                                                    @if(obj == 'Perplexity'){
                                                        <li class="list-inline-item">
                                                            <button type="button" class="btn btn-outline-light btn-bot bot-perplexity" (click)="summarize(obj)" [title]="obj"></button>
                                                        </li>
                                                    }
                                                }
                                            </ul>
                                        }
                                    </div>
                                </div>
                            </div>
                            <h1 class="fs-4 fw-bold lh-base">{{article()?.title!}}</h1>
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="fs-7 fw-medium inter mb-3 mt-3">
                                        <div class="author-img border border-light d-inline-block rounded-circle">
                                            <a [routerLink]="['/authors', article()?.authorSlug!, 3, 1]">
                                                <img [src]="article()?.authorImg" [alt]="article()?.author" class="w-100 object-fit-cover">
                                            </a>
                                        </div>
                                        <div class="author">
                                            <a [routerLink]="['/authors', article()?.authorSlug!, 3, 1]" class="text-decoration-none text-dark">{{article()?.author!}}</a>
                                            <span>
                                                <img src="assets/icons/calendar.svg" [alt]="(article()?.createdAt | date: 'mediumDate')"> 
                                                {{article()?.createdAt! | date: 'mediumDate'}}
                                            </span>
                                            <span>
                                                <img src="assets/icons/clock.svg" [alt]="article()?.minsRead + ' mins' + ' read'"> 
                                                {{article()?.minsRead!}} min{{article()?.minsRead! > 1 ? 's' : ''}} read
                                            </span>
                                            @if(article()?.isFeatured!){
                                                <span>
                                                    <img src="assets/icons/featured_badge.svg" alt="Featured"> 
                                                    <a [routerLink]="['/featured', 3, 1]" class="text-decoration-none text-dark ps-1">Featured</a>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="share-btn">
                                        <span class="d-inline-flex align-items-center float-end ms-3">
                                            <div class="fb-share-button"
                                                [attr.data-href]="article()?.canonical"
                                                data-layout="button"
                                                data-size="small">
                                            </div>
                                        </span>
                                        <span class="d-inline-flex align-items-center twitter-x-btn float-end ms-3">
                                            <a href="https://twitter.com/share"
                                            class="twitter-share-button"
                                            [attr.data-url]="article()?.canonical"
                                            [attr.data-text]="article()?.title"
                                            data-show-count="false"
                                            data-size="small">
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="article-content">
                                <div [innerHtml]="article()?.content!" class="article-content pt-2 lh-lg fw-medium inter"></div>
                            </div>
                            <div class="fs-7 pb-2 mb-2 inter">
                                @for (obj of article()?.tags; track obj.slug) {
                                    <a [routerLink]="['/tags', obj.slug , 3, 1]" class="text-decoration-none border border-gray rounded-4 py-1 px-2 text-dark tag d-inline-block mb-3 me-3 ms-0">{{obj.tag}}</a>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div class="col-lg-4">
                    <div class="position-sticky widget">
                        @if(!isLoading()){
                            <app-widget-related [category]="article()?.categorySlug!" [exclude]="article()?.slug!" ></app-widget-related>
                        }
                        <app-widgets></app-widgets>
                    </div>
                </div>
            </div>
        </div>
    <app-footer></app-footer>
}@else{
    <app-page-not-found></app-page-not-found>
}